const regions = {
  'Auvergne-Rhône-Alpes': 'auvergne-rhone-alpes',
  'Bourgogne-Franche-Comté': 'bourgogne-franche-comte',
  Bretagne: 'bretagne',
  Corse: 'corse',
  'Centre-Val de Loire': 'centre-val-de-loire',
  'Grand Est': 'grand-est',
  Guadeloupe: 'guadeloupe',
  Guyane: 'guyane',
  'Hauts-de-France': 'hauts-de-france',
  'La Réunion': 'la-reunion',
  Martinique: 'martinique',
  Mayotte: 'mayotte',
  Normandie: 'normandie',
  'Nouvelle-Aquitaine': 'nouvelle-aquitaine',
  'Nouvelle-Calédonie': 'nouvelle-caledonie',
  Occitanie: 'occitanie',
  'Pays de la Loire': 'pays-de-la-loire',
  'Polynésie française': 'polynesie-française',
  'Provence-Alpes-Côte d\'Azur': 'provence-alpes-cote-d-azur',
  'Île-de-France': 'ile-de-france'
}

export default regions
